module.exports = __webpack_public_path__ + "img/mobile-header-ru.abfde29b.jpg";